var _defineProperty = require("/home/runner/work/darthsteven_com/darthsteven_com/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Iconv = require('iconv-lite');

var jschardet = require('jschardet');

var _require = require('./parse'),
    parse = _require.parse;
/* eslint-disable no-param-reassign */


exports.parseInput = function parseInput(qifData, options, callback) {
  if (!callback) {
    callback = options;
    options = {};
  }

  var _jschardet$detect$opt = _objectSpread(_objectSpread({}, jschardet.detect(qifData)), options),
      encoding = _jschardet$detect$opt.encoding;

  var err;

  if (encoding.toUpperCase() !== 'UTF-8' && encoding.toUpperCase() !== 'ASCII') {
    qifData = Iconv.decode(Buffer.from(qifData), encoding);
  } else {
    qifData = qifData.toString('utf8');
  }

  try {
    qifData = parse(qifData, options);
  } catch (e) {
    err = e;
  }

  callback(err || undefined, qifData);
};
/* eslint-enable no-param-reassign */